import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "row"]

  filter() {
    const filterValue = this.inputTarget.value.toLowerCase()
    let visibleCount = 0

    this.rowTargets.forEach(row => {
      const company = row.querySelector('[data-search-company]')?.textContent?.toLowerCase() || ""
      const branch = row.querySelector('[data-search-branch]')?.textContent?.toLowerCase() || ""

      if (company.includes(filterValue) || branch.includes(filterValue)) {
        row.style.display = ""
        visibleCount++
      } else {
        row.style.display = "none"
      }
    })

    const emptyState = this.element.querySelector('[data-empty-state]')
    if (emptyState) {
      if (visibleCount === 0 && this.rowTargets.length > 0) {
        emptyState.style.display = ""
      } else {
        emptyState.style.display = "none"
      }
    }
  }
}
